<script lang="ts" setup>
import { toRefs, watch } from 'vue';
import { type GoToItem, NAVIGATION_ITEMS } from '../../types';
import BookmarksTab from '../bookmarks/BookmarksTab.vue';
import HighlightsTab from '../highlights/HighlightsTab.vue';

type Emits = {
  (e: 'goToBookmark', item: GoToItem): void;
  (e: 'goToAnnotation', item: GoToItem): void;
  (e: 'resetSearch'): void;
};
const emit = defineEmits<Emits>();

type Props = {
  tab: number;
  search: string;
  annotationItems: readonly string[];
  bookId: string;
  profileId?: string;
};
const props = defineProps<Props>();

const { tab, search } = toRefs(props);

watch(tab, () => {
  if (search.value) emit('resetSearch');
});

const componentMap: Record<string, any> = {
  [NAVIGATION_ITEMS.BOOKMARKS_LIST]: BookmarksTab,
  [NAVIGATION_ITEMS.HIGHLIGHT_LIST]: HighlightsTab,
};
</script>

<template>
  <component
    :is="componentMap[annotationItems[tab]]"
    :search="search"
    :book-id="bookId"
    :profile-id="profileId"
    @go-to-bookmark="emit('goToBookmark', $event)"
    @go-to-annotation="emit('goToAnnotation', $event)"
  />
</template>
